import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '@/views/HomePage.vue'
import TransportPage from '@/views/TransportPage.vue'
import RoutePage from '@/views/RoutePage.vue'
import AboutPage from '@/views/AboutPage.vue'
import ContactPage from '@/views/ContactPage.vue'
import { getCopy } from '@/locale'

Vue.use(VueRouter)

/** 中英文共用页面组件，用 meta.lang 区分 */
function pageRoutes(lang) {
  const prefix = lang === 'en' ? '/en' : ''
  return [
    {
      path: lang === 'en' ? '/en' : '/',
      name: lang === 'en' ? 'HomeEn' : 'Home',
      component: HomePage,
      meta: { lang: lang, titleKey: 'nav.home' }
    },
    {
      path: prefix + '/transport',
      name: lang === 'en' ? 'TransportEn' : 'Transport',
      component: TransportPage,
      meta: { lang: lang, titleKey: 'nav.transport' }
    },
    {
      path: prefix + '/route',
      name: lang === 'en' ? 'RouteEn' : 'Route',
      component: RoutePage,
      meta: { lang: lang, titleKey: 'nav.route' }
    },
    {
      path: prefix + '/about',
      name: lang === 'en' ? 'AboutEn' : 'About',
      component: AboutPage,
      meta: { lang: lang, titleKey: 'nav.about' }
    },
    {
      path: prefix + '/contact',
      name: lang === 'en' ? 'ContactEn' : 'Contact',
      component: ContactPage,
      meta: { lang: lang, titleKey: 'nav.contact' }
    }
  ]
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: pageRoutes('zh').concat(pageRoutes('en')),
  scrollBehavior(to, from) {
    if (to.hash) {
      return new Promise(function (resolve) {
        setTimeout(function () {
          resolve({ selector: to.hash, offset: { x: 0, y: 104 } })
        }, 80)
      })
    }
    if (from && to.path === from.path) {
      return { x: window.pageXOffset, y: window.pageYOffset }
    }
    return { x: 0, y: 0 }
  }
})

router.beforeEach(function (to, from, next) {
  const lang = to.meta && to.meta.lang === 'en' ? 'en' : 'zh'
  const copy = getCopy(lang)
  const titleKey = to.meta && to.meta.titleKey ? to.meta.titleKey : 'nav.home'
  const pageTitle = (copy.nav && copy.nav[titleKey.replace('nav.', '')]) || copy.nav.home
  document.title = pageTitle + ' - ' + copy.common.titleSuffix
  next()
})

export default router
